import { Button, Form, Input, Modal, Select, Upload } from "antd";
import { t } from "i18next";
import React from "react";
import { BsPlusCircle } from "react-icons/bs";
import styles from "./SupplierList.module.css";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

type FormData = {
  bussinessType: string;
  catagory: string;
  productName: string;
  amount: number;
  unit: string;
  dateOfRequireProduct: string;
  image: string[];
  contact: string;
  dateOfBid: string;
};

const NewAnnounce = () => {
  const [visibleModal, setVisibleModal] = React.useState<boolean>(false);

  const [form] = Form.useForm<FormData>();
  const closeModal = React.useCallback(() => {
    setVisibleModal(false);
  }, []);
  const openModal = React.useCallback(() => {
    setVisibleModal(true);
  }, []);

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  const onFinish = (values: any) => {
    console.log(values);
  };

  const onReset = () => {
    form.resetFields();
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <>
      <button
        className="request-button-new"
        id="NewRequest"
        onClick={openModal}
        style={{ backgroundColor: "#025A9D" }}
      >
        <BsPlusCircle />
        <p className="custom-font">{t("Create a new announcement")}</p>
      </button>
      {visibleModal && (
        <Modal
          destroyOnClose
          closable={false}
          maskClosable={false}
          title={
            <div
              style={{
                backgroundColor: "#C95559",
                color: "white",
                fontSize: "1.3rem",
                fontWeight: "bold",
                padding: "6px 6px 6px 10px",
              }}
            >
              ระบุข้อมูลสินค้าที่ต้องการใบเสนอราคา
            </div>
          }
          visible={visibleModal}
          onCancel={closeModal}
          onOk={() => {}}
          width={800}
          style={{ minHeight: "500px" }}
          footer={null}
          centered
        >
          <Form
            {...layout}
            layout="horizontal"
            form={form}
            name="control-hooks"
            onFinish={onFinish}
            style={{ padding: "0 40px 0 40px", margin: 0 }}
          >
            <Form.Item
              name="bussinessType"
              label="เลือกประเภทกิจการ"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select a option and change input text above"
                // onChange={onGenderChange}
                allowClear
              >
                <Option value="male">male</Option>
                <Option value="female">female</Option>
                <Option value="other">other</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="catagory"
              label="เลือกหมวดหมู่สินค้า/บริการ"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select a option and change input text above"
                // onChange={onGenderChange}
                allowClear
              >
                <Option value="male">male</Option>
                <Option value="female">female</Option>
                <Option value="other">other</Option>
              </Select>
            </Form.Item>
            {/* <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.gender !== currentValues.gender
              }
            >
              {({ getFieldValue }) =>
                getFieldValue("gender") === "other" ? (
                  <Form.Item
                    name="customizeGender"
                    label="Customize Gender"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                ) : null
              }
            </Form.Item> */}
            <Form.Item
              name="productName"
              label="ชื่อสินค้า/บริการที่ต้องการ"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="amount"
              label="จำนวนสินค้า"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="unit"
              label="หน่อยนับ"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="dateOfRequireProduct"
              label="วันที่ต้องการสินค้า/บริการ"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="รูปภาพตัวอย่างสินค้า" valuePropName="image">
              <Upload action="/upload.do" listType="picture-card" multiple>
                <div>
                  <PlusOutlined rev={undefined} />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              </Upload>
            </Form.Item>
            <Form.Item
              name="contact"
              label="ช่องทางติดต่อกลับ"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="dateOfBid"
              label="กรุณาเสนอราคาภายในวันที่"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <div className={styles.form_footer}>
              <Button
                type="ghost"
                style={{
                  backgroundColor: "#C95559",
                  color: "white",
                  width: "200px",
                  borderRadius: "4px",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  height: "50px",
                }}
                htmlType="button"
                onClick={closeModal}
                size="large"
              >
                ยกเลิก
              </Button>
              <Button
                type="primary"
                style={{
                  width: "200px",
                  backgroundColor: "#6598F6",
                  color: "white",
                  borderRadius: "4px",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  height: "50px",
                }}
                htmlType="submit"
                size="large"
              >
                ส่งคำขอใบเสนอราคา
              </Button>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default NewAnnounce;
